<ng-container>
  <div class="modal-header">
    @if ((isEditing$ | async) === true) {
      <h4 class="modal-title" id="participantModalLabel">Edit Participant</h4>
    } @else {
      <h4 class="modal-title" id="participantModalLabel"> Add Participant</h4>
    }
    <p>*Required Information</p>
  </div>
  @if ((currentForm$ | async) === FormName.ParticipantInformation) {
    <app-participant-information-form
      [userRoles]="userRoles"
      [sequenceNumbers]="sequenceNumbers"
      [verificationTypes]="verificationTypes"
      [selectedParticipant]="selectedParticipant"
      [orderId]="order.id"
      [participantPresignStatuses]="participantPresignStatuses"
    ></app-participant-information-form>
  }
  @if ((currentForm$ | async) === FormName.NonBorrowingTitleHolderInformation) {
    <app-non-borrowing-title-holder-information-form
      [userRoles]="userRoles"
      [sequenceNumbers]="sequenceNumbers"
      [verificationTypes]="verificationTypes"
      [selectedParticipant]="selectedParticipant"
      [orderId]="order.id"
      [participantPresignStatuses]="participantPresignStatuses"
    ></app-non-borrowing-title-holder-information-form>
  }
  @if ((currentForm$ | async) === FormName.WitnessInformation) {
    <app-witness-information-form
      [userRoles]="userRoles"
      [sequenceNumbers]="sequenceNumbers"
      [verificationTypes]="verificationTypes"
      [selectedParticipant]="selectedParticipant"
      [orderId]="order.id"
      [participantPresignStatuses]="participantPresignStatuses"
    ></app-witness-information-form>
  }
  @if ((currentForm$ | async) === FormName.SigningAgentInformation) {
    <app-signing-agent-information-form
      [userRoles]="userRoles"
      [sequenceNumbers]="sequenceNumbers"
      [selectedParticipant]="selectedParticipant"
      [clients]="clients"
      [orderId]="order.id"
    ></app-signing-agent-information-form>
  }
</ng-container>
